import React from "react";
import { Grid, Container } from "semantic-ui-react";
import {
  Heading2,
  Body2,
} from "../../../components/value-cssmodules/TextComponent";
import styles from "./Invitation.module.scss";
import { FormattedMessage } from "react-intl";
import MainButton from "../../../components/Button/MainButton";

const Invitation = () => {
  const benes = [
    {
      url: `/bene/003-hand.svg`,
      titleId: "home.designers.benefit.1.title",
      subtitleId: "home.designers.benefit.1.subtitle",
    },
    {
      url: `/bene/005-yoga.svg`,
      titleId: "home.designers.benefit.2.title",
      subtitleId: "home.designers.benefit.2.subtitle",
    },
    {
      url: `/bene/007-social-care.svg`,
      titleId: "home.designers.benefit.3.title",
      subtitleId: "home.designers.benefit.3.subtitle",
    },
    {
      url: `/bene/004-tag.svg`,
      titleId: "home.designers.benefit.4.title",
      subtitleId: "home.designers.benefit.4.subtitle",
    },
    {
      url: `/bene/006-meditation.svg`,
      titleId: "home.designers.benefit.5.title",
      subtitleId: "home.designers.benefit.5.subtitle",
    },
  ];

  return (
    <section className={styles.invitation}>
      <Grid padded>
        <Grid.Row columns={1}>
          <Container>
            <Grid.Column>
              <Heading2>
                <FormattedMessage
                  id={"nav.headingInvitationDHP"}
                  defaultMessage={"See what you get with Sewlight"}
                />
              </Heading2>
              <Body2>
                <FormattedMessage
                  id={"nav.bodyInvitationDHP"}
                  defaultMessage={"Discover all the benefits of working with us"}
                />
              </Body2>
            </Grid.Column>
          </Container>
        </Grid.Row>
        <Grid.Row columns={5}>
          {benes.map((bene: any, i: number) => (
            <Grid.Column key={`${bene.titleId}-${i}`} textAlign="center">
              <p>
                <FormattedMessage
                  id={bene.titleId}
                  defaultMessage="Benefit title"
                />
              </p>
              <p>
                <FormattedMessage
                  id={bene.subtitleId}
                  defaultMessage="Benefit subtitle"
                />
              </p>
            </Grid.Column>
          ))}
        </Grid.Row>
        <Grid.Row column={1}>
          <Grid.Column textAlign="center">
            <MainButton>
              <FormattedMessage
                id={"nav.register"}
                defaultMessage={"Register"}
              />
            </MainButton>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </section>
  );
};

export default Invitation;
